/* target_link.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.32 19.89" xml:space="preserve">
            <path class="foreground-gl" d="M10.75.55,14.49,4.3a.75.75,0,0,1,.22.53V19.47a.76.76,0,0,1-.75.75H1.14a.76.76,0,0,1-.75-.75V1.09A.76.76,0,0,1,1.14.33h9.08A.75.75,0,0,1,10.75.55ZM10.24,5l3.57,0L10,1.11V4.78A.26.26,0,0,0,10.24,5ZM7.46,6.73a5.65,5.65,0,1,0,5.65,5.65A5.65,5.65,0,0,0,7.46,6.73Z" transform="translate(-0.39 -0.33)"/>
            <path class="foreground-gl" d="M11.4,12.38A3.94,3.94,0,1,1,7.47,8.45,3.93,3.93,0,0,1,11.4,12.38ZM7.47,10.31A2.09,2.09,0,1,0,9.55,12.4,2.09,2.09,0,0,0,7.47,10.31Z" transform="translate(-0.39 -0.33)"/>
        </svg>
    `
};
